import { useMemo } from 'react';
import { resolveVariableUnit } from '../../../../../../units';

export const useDuvalPentagonSeries = (variables, variablesIndex, configuration) => {
  return useMemo(
    () =>
      variables.map(({ id, aggregate, label, unit, unitLabel, decimals }) => {
        const { name } = (variablesIndex || {})[id] || {};
        const seriesId = `${id}.${aggregate}`;
        const { displayUnit, customUnit } = resolveVariableUnit(
          unit,
          unitLabel,
          (variablesIndex || {})[id]?.unit
        );

        return {
          variableId: id,
          id: seriesId,
          label: label || name,
          decimals: decimals || 'auto',
          unit: displayUnit,
          customUnit,
          aggregate,
        };
      }),
    [variables, variablesIndex, configuration]
  );
};
